import React from 'react';

const NewsDate = ({date} : {date: string}) => {
    return (
        <>
            {date.split("T")[0].split("-")[2]}.{date.split("T")[0].split("-")[1]}.{date.split("T")[0].split("-")[0]}
        </>
    );
};

export default NewsDate;